import { configureStore, Middleware } from '@reduxjs/toolkit';
import logger from 'redux-logger';

import { api } from '~/services/api';
import rootReducer from './root-reducer';

export const rtkQueryErrorLogger: Middleware = () => next => action => {
  return next(action);
};

const configureStoreWith = (() => {
  
  const store = configureStore({
    reducer: rootReducer,
    // devTools: true,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware()
        .concat(logger as Middleware)
        .concat(api.middleware)
        .concat(rtkQueryErrorLogger),
  });

  return store;
})();

export default configureStoreWith;

export type RootState = ReturnType<typeof configureStoreWith.getState>;
export type AppDispatch = typeof configureStoreWith.dispatch;
